
import Group from 'vux/src/components/group/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
directives: {
TransferDom
},
components: {Group, PopupPicker, XDialog, XButton, XInput, Selector},
name: 'ProductsCenter',
data() {
return {
productsList: [





















],
housingLoan: {
houseprovince: [],
housecity: [],
product: []
},
dialoaData: {
inputType: [],//录入类型
cityCode: [],
organId: []
},
houseprovince: '',
housecity: '',
product: '',
popupList: {
province: [],
city: [],
products: []
},
provinceList: [],
cityList: [],
productList: [],
dialogType: false,
dialogTitle: '',
organList: [],
cityCodeList: []
}
},
created() {
this.checkUserStatus()
this.getProductList()
this.getProvinceList()
},
computed: {
sortProductList() {
return this.sortByKey(this.productsList, 'productCode')
},
showDialog() {
return !!this.dialogType
}
},
methods: {

checkUserStatus() {
const openId = window.sessionStorage.getItem("openId");
if (!openId) {
return;
}
const url = '/wechat/queryUser.do?openId=' + openId;
this.$axios({
method: 'get',
url: url
}).then((response) => {
if (response.data.code !== 200) {
return;
}
const wechatInfo = response.data.result || {};
const status = wechatInfo.espstatus;

if (String(status) === '0' || !status) {
this.$router.push({path: '/register'});
} else if (String(status) === '1' || String(status) === '3') {

this.$router.push({path: '/personInfo'});
} else if (String(status) === '2') {

if (this.isCertExpiringSoon(wechatInfo.certExpireTime)) {

this.$vux.confirm.show({
title: '提示',
content: '您的实名证书即将过期，如果继续办理业务可能会影响签章。建议先去重新实名认证后再进行业务。',
showCancelButton: false,
confirmText: '我知道了'
});
}
}
}).catch(() => {
});
},


isCertExpiringSoon(certExpireTime) {
if (!certExpireTime) {
return false;
}

const match = String(certExpireTime).trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
if (!match) {
return false;
}
const expireYear = Number(match[1]);
const expireMonth = Number(match[2]) - 1; 
const expireDay = Number(match[3]);
const now = new Date();

const expireMs = Date.UTC(expireYear, expireMonth, expireDay);
const todayMs = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
const diffDays = Math.round((expireMs - todayMs) / (24 * 60 * 60 * 1000));
return diffDays >= 0 && diffDays <= 30;
},
async getOrganList(cityCode = null) {

try {
if (!cityCode && this.cityCodeList.length) {
return
}
const {data: {result = []}} = await this.$axios({
method: 'post',
url: '/wechat/queryOrgMsg.do',
data: {orgName: cityCode}
})
if (!cityCode) {
this.cityCodeList = result.map(item => item.cityCode)
} else {
this.dialoaData.organId = []
this.organList = result.map(item => {
return {
value: item.organId,
name: item.nameCode
}
})
}
} catch (error) {
console.log(error)
return false
}
},
getImage(id) {
return require(`@/assets/images/${id}.png`);
},

getProductList() {
const $this = this
const url = '/wechat/getProductList.do'
this.$axios({
method: 'get',
url: url
}).then((response) => {
if (response.data.code === 200) {
$this.productsList = response.data.result
} else {
$this.$vux.toast.text(response.data.message)
}
})
},
productClick(num) {

if (num === '0' || num === 0) {
this.dialogType = '1'
this.dialogTitle = '请选择省市信息和产品'
} else if (+num === 3) {

this.dialogType = '3'
this.dialogTitle = '请选择类型和机构'
this.getOrganList()
} else {
this.$router.push({name: 'ProductDetail', query: {productCode: num}})
}
},

async dialogSubmit() {
if (this.dialogType == '1') {
if (this.product && this.product !== '') {
this.$router.push({name: 'ProductDetail', query: {productCode: '0', productId: this.product.productId}})
} else {
this.$vux.toast.text('请选择产品！')
}
} else if (this.dialogType == '3') {
if (!this.dialoaData.inputType || this.dialoaData.inputType.length < 1) {
this.$vux.toast.text('请选择录入类型！')
return
}
if (this.dialoaData.inputType && this.dialoaData.inputType[0] == '机构') {
if (!this.dialoaData.cityCode || this.dialoaData.cityCode.length < 1) {
this.$vux.toast.text('请选择城市编号！')
return
}
if (!this.dialoaData.organId || this.dialoaData.organId.length < 1) {
this.$vux.toast.text('请选择机构编号！')
return
}
if (this.dialoaData.organId && this.dialoaData.organId[0]) {
this.$router.push({name: 'ProductDetail', query: {productCode: '3', organId: this.dialoaData.organId[0]}})
}
} else {
this.$router.push({name: 'ProductDetail', query: {productCode: '3', organId: ''}})
}

}
},

getProvinceList() {
const $this = this
const url = '/wechat/queryAreaList.do?pId=' + 35
this.$axios({
method: 'get',
url: url
}).then((response) => {
if (response.data.code === 200) {
$this.provinceList = response.data.result
$this.popupList.province = [$this.initPopupList($this.provinceList)];
} else {
$this.$vux.toast.text(response.data.message)
}
}).catch(function (err) {
$this.$vux.toast.text(err)
})
},

getCityList(pId) {
const $this = this
const url = '/wechat/queryAreaList.do?pId=' + pId
this.$axios({
method: 'get',
url: url
}).then((response) => {
if (response.data.code === 200) {
$this.cityList = response.data.result
$this.popupList.city = [$this.initPopupList($this.cityList)];
} else {
$this.$vux.toast.text(response.data.message)
}
}).catch(function (err) {
$this.$vux.toast.text(err)
})
},

getProductsList(houseprovince, housecity) {
const $this = this
const url = '/wechat/getProductName.do?houseprovince=' + houseprovince + '&housecity=' + housecity
this.$axios({
method: 'get',
url: url
}).then((response) => {
if (response.data.code === 200) {
if (response.data.result.length > 0) {
$this.productList = response.data.result
$this.popupList.products = [$this.initPopupList($this.productList)];
} else {
$this.$vux.toast.text('此省市下无顺易贷产品，请重新选择')
}
} else {
$this.$vux.toast.text(response.data.message)
}
}).catch(function (err) {
$this.$vux.toast.text(err)
})
},

initPopupList(list) {
let newList = []
for (let i = 0; i < list.length; i++) {
newList.push(list[i].name)
}
return newList
},

provinceChange(val) {
this.cityList.length = 0
this.popupList.city.length = 0
this.housingLoan.housecity = []
this.housecity = ''
this.productList.length = 0
this.popupList.products.length = 0
this.housingLoan.product = []
this.product = ''
this.houseprovince = this.provinceList.find(item => {
return item.name === val[0]
})
this.getCityList(this.houseprovince.id)
},

cityChange(val) {
this.productList.length = 0
this.popupList.products.length = 0
this.housingLoan.product = []
this.product = ''
this.housecity = this.cityList.find(item => {
return item.name === val[0]
})
if (this.houseprovince !== '' && this.housecity !== '' && this.houseprovince && this.housecity)
this.getProductsList(this.houseprovince.id, this.housecity.id)
},

productChange(val) {
this.product = this.productList.find(item => {
return item.name === val[0]
})
},
sortByKey(array, key) {
return array.sort(function (a, b) {
var x = a[key];
var y = b[key];
return ((x < y) ? -1 : ((x > y) ? 1 : 0));
})
}

}
}



// WEBPACK FOOTER //
// ./src/pages/ProductsCenter.vue